export const deriveInitials = (user) => {
  const source = (user?.initials || user?.displayName || user?.username || '?').trim();
  return (source.slice(0, 2) || '?').toUpperCase();
};

export const normalizeUser = (user) => ({
  name: user?.displayName || user?.username || '用户',
  initials: deriveInitials(user),
  role: user?.roleName || 'ERP 用户',
});

export const isAuthenticatedUser = (user) => Boolean(user?.authenticated ?? user?.isLogin);

export const createAuthBootstrap = ({
  api,
  readToken,
  clearToken,
  loadApplicationData,
  setAuthenticated,
  setAuthChecked,
  updateUserSettings,
}) => async () => {
  const token = readToken();
  if (!token) {
    setAuthenticated(false);
    setAuthChecked(true);
    return false;
  }

  try {
    const user = await api.me();
    if (!isAuthenticatedUser(user)) {
      clearToken();
      setAuthenticated(false);
      return false;
    }
    updateUserSettings(normalizeUser(user));
    setAuthenticated(true);
    loadApplicationData();
    return true;
  } catch (error) {
    clearToken();
    setAuthenticated(false);
    return false;
  } finally {
    setAuthChecked(true);
  }
};
